import React from 'react';
import type { FC } from 'react';
import { Link, LinkProps, withStyles } from '@material-ui/core';
import { theme } from '../theme/mui-theme';
import Title from './typography/Title';

const StyledLink = withStyles({
  root: {
    color: theme.palette.text.primary,
    textDecoration: 'underline'
  }
})(Link);

const TitleLink : FC<LinkProps> = (props) => {
  return (
    <Title>
      <StyledLink { ...props } />
    </Title>
  );
};

export default TitleLink;
